import React from 'react'
import { Link } from 'gatsby'
import styled from '@emotion/styled'
import { Swiper, SwiperSlide } from 'swiper/react'
import { BsArrowUpRightCircleFill } from 'react-icons/bs'

import { PostListProps } from '~/types/post.types'

import Route from '~/constants/route'
import palette from '~/styles/palette'
import { ReactiveWrapper } from '~/styles/image'

import { PostItem } from '~/components/common'

const MAX_ITEM_LENGTH = 5

const Slider: React.VFC<PostListProps> = ({ postList }) => {
  return (
    <Swiper freeMode slidesPerView="auto">
      {postList.slice(0, MAX_ITEM_LENGTH).map(({ node }) => (
        <SwiperSlide key={node.id}>
          <Link to={node.fields?.slug as string}>
            <PostItem
              {...node.frontmatter}
              timeToRead={node.timeToRead}
              excerpt={node.excerpt}
              onlyMW
            />
          </Link>
        </SwiperSlide>
      ))}

      <SwiperSlide>
        <Link to={Route.post}>
          <ReactiveWrapper height="93%">
            <MoreWrapper>
              더 보러가기
              <BsArrowUpRightCircleFill fill={palette.purple} />
            </MoreWrapper>
          </ReactiveWrapper>
        </Link>
      </SwiperSlide>
    </Swiper>
  )
}

const MoreWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 10px;

  ${({ theme: { typography } }) => typography.body1}
  color: #999;
`

export default Slider
